import type { FC } from 'react';
import './TableRow.scss'
import type { ITableData } from '../../models/ITableData';
import { formatNumber } from '../utils/utils';

interface TableRowProps {
    data: ITableData
}

export const TableRow: FC<TableRowProps> = ({ data }) => {

    const percent = data.yesterday ? (((data.currentDay - data.yesterday) / data.yesterday) * 100).toFixed(0) : 0;
    const percentNumber = Number(percent);
    const changeClassPercentTd = percentNumber > 0 ? 'table__cell_green' : (percentNumber < 0 ? 'table__cell_red' : '');
    const changeClassPercentSpan = percentNumber >= 0 ? 'table__percent_positive' : (percentNumber < 0 ? 'table__percent_negative' : '');
    const changeClassthisWeek = data.currentDay > data.thisWeek ? 'table__cell_green' : (data.currentDay < data.thisWeek ? 'table__cell_red' : '');

    return (
        <>
            <td className="table__cell table__cell_indicator">{data.indicator}</td>
            <td className="table__cell table__cell_blue">{formatNumber(data.currentDay)}</td>
            <td className={`table__cell ${changeClassPercentTd}`}>
                {formatNumber(data.yesterday)}
                <span className={`table__percent ${changeClassPercentSpan}`}>{percent}%</span>
            </td>
            <td className={`table__cell ${changeClassthisWeek}`}>{formatNumber(data.thisWeek)}</td>
        </>
    )
}